import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { flattenTree } from '../utils/tree';
import {
  FlattenedItem,
  FlattenedTree,
  ItemId,
  Path,
  TreeData,
  TreeItem as Item,
  RenderItemParams,
} from '../types';

const Container = styled.div`
  height: 100%;
`;

export type Props = {
  tree: TreeData;
  query?: string;
  onExpand: (itemId: ItemId) => void;
  onCollapse: (itemId: ItemId) => void;
  renderItem: (item: RenderItemParams) => React.ReactNode;
  onDoubleClickItem: (input: Item) => void;
  onUpload: (itemPath: Path) => void;
};

const Tree = (props: Props) => {
  const [flatTree, setFlatTree] = useState<FlattenedTree>([]);

  const {
    tree,
    query,
    renderItem,
    onExpand,
    onCollapse,
    onDoubleClickItem,
    onUpload,
  } = props;

  useEffect(() => {
    const flattenedTree = flattenTree(tree);
    setFlatTree(flattenedTree);
  }, [tree]);

  const treeResults = flatTree.map((flatItem: FlattenedItem) =>
    renderItem({
      depth: flatItem.path.length - 1,
      key: flatItem.item.id,
      item: flatItem.item,
      path: flatItem.path,
      query,
      onCollapse,
      onDoubleClickItem,
      onExpand,
      onUpload,
    }),
  );

  return <Container data-test="tree">{treeResults}</Container>;
};

export default Tree;
